import { useTranslation } from "@coworker/locales";
import { useState } from "react";
import Linkbar from "../../shared/components/Linkbar/Linkbar";
import FixaButton from "../../shared/wrappers/FixaButton/FixaButton";
import FixaLink from "../../shared/wrappers/FixaLink/FixaLink";
import { MediaCard } from "../components/MediaCard/MediaCard";
import { UploadMediaModal } from "../components/UploadMediaModal/UploadMediaModal";
import styles from "./launch-media-page.module.css";
import { mediaCards } from "./mock-media";

const LaunchMediaPage = () => {
  const { t } = useTranslation();
  const [uploadMediaModalIsOpen, setUploadMediaModalIsOpen] = useState(false);

  return (
    <main className={styles["page"]}>
      <Linkbar currentLabel={t("capitalCaseLaunchMediaString")} currentAsH1 />

      <div className={styles["actions"]}>
        <FixaButton
          className={styles["trigger"]}
          htmlType="button"
          onClick={() => setUploadMediaModalIsOpen(true)}
          text={t("uploadString")}
          type="emphasised"
        />
        <UploadMediaModal
          isOpen={uploadMediaModalIsOpen}
          onFilesSelected={() => setUploadMediaModalIsOpen(false)}
          onClose={() => setUploadMediaModalIsOpen(false)}
        />
      </div>

      <section className={styles["grid"]} aria-label="Launch media">
        {mediaCards.map(
          ({
            imageUrl,
            imageAlt,
            badgeLabel,
            title,
            fiscalYear,
            mediaType,
            status,
          }) => (
            <FixaLink key={title} to="/launch-media">
              <MediaCard
                imageUrl={imageUrl}
                imageAlt={imageAlt}
                badgeLabel={badgeLabel}
                title={title}
                fiscalYear={fiscalYear}
                mediaType={mediaType}
                status={status}
              />
            </FixaLink>
          )
        )}
      </section>
    </main>
  );
};

export default LaunchMediaPage;
